import { SubscriptionPlanBenefitsListItem } from './components/SubscriptionPlanFeaturesList/SubscriptionPlanBenefitsList';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckRedIcon, UncheckedRedIcon } from 'app/components/icons';

export default function useBasicBenefitsList() {
  const { t } = useTranslation();

  return React.useMemo((): SubscriptionPlanBenefitsListItem[] => {
    return [
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.two_telematics_updates_per_day',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.current_machine_hours',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.current_machine_vitals',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.current_machine_fault_codes',
        ),
      },
      {
        icon: CheckRedIcon,
        text: t(
          'subscriptions.manage_your_plan.benefits.current_machine_location',
        ),
      },
      {
        icon: UncheckedRedIcon,
        text: (
          <span className="basic-info-plan-card__disabled-benefits">
            {t('subscriptions.manage_your_plan.benefits.inhibit_restart')}
          </span>
        ),
      },
      {
        icon: UncheckedRedIcon,
        text: (
          <span className="basic-info-plan-card__disabled-benefits">
            {t('subscriptions.manage_your_plan.benefits.aemp')}
          </span>
        ),
      },
      {
        icon: UncheckedRedIcon,
        text: (
          <span className="basic-info-plan-card__disabled-benefits">
            {t(
              'subscriptions.manage_your_plan.benefits.enhanced_notifications',
            )}
          </span>
        ),
      },
    ];
  }, [t]);
}
